/**
 * search_tools — canonical schema (single source of truth).
 *
 * ZERO imports. Isomorphic: importable by both gui/ and tool-runtime/.
 *
 * Looks up a tool by exact name and returns its full definition as text.
 * The AI must call this before using any discoverable tool to read its schema.
 *
 * Handled directly by the agent loop (like task_complete) — never dispatched
 * to an external handler.
 */

export const MANIFEST = {
  name: 'search_tools',
  description: `Look up the full definition of a tool by its exact name.

Returns the tool's description and complete input schema.

**NEVER assume how a tool works or what parameters it takes.**
ALWAYS call this first to get the exact definition before calling any tool in AVAILABLE_TOOLS.

Pass the exact tool name from the AVAILABLE_TOOLS list — no keywords or fuzzy terms.

**Examples:**
- search_tools({ name: "email_send" })       → returns email_send schema
- search_tools({ name: "note_write" })       → returns note_write schema
- search_tools({ name: "tasks_read" })       → returns tasks_read schema
- search_tools({ name: "contacts_create" })  → returns contacts_create schema`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      name: {
        type: 'string',
        description: 'Exact tool name from the AVAILABLE_TOOLS list (e.g. "email_send", "note_write")',
      },
    },
    required: ['name'] as const,
  },
} as const;
